import { Group, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { DateRangeSelects, UniversalSelect } from '@feathr/components';
import type { IDateRangeOption } from '@feathr/extender/hooks';
import { flattenError } from '@feathr/hooks';

export interface IDateRangeSelectProps {
  customDateRange: [string | undefined, string | undefined];
  dateRangeOptions: IDateRangeOption[];
  onDateRangeChange: (option: IDateRangeOption) => void;
  onCustomDateRangeChange: (value: [string | undefined, string | undefined]) => void;
  selectedDateRange: string;
  validationError: string[] | undefined;
  label?: string;
  menuPortalTarget?: HTMLElement;
  name?: string;
}

function DateRangeSelect({
  customDateRange,
  dateRangeOptions,
  onDateRangeChange,
  onCustomDateRangeChange,
  selectedDateRange,
  validationError,
  label,
  menuPortalTarget,
  name = 'date_range',
}: Readonly<IDateRangeSelectProps>): JSX.Element {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  return (
    <>
      <UniversalSelect<IDateRangeOption>
        label={label ?? t('Date range')}
        menuPortalTarget={menuPortalTarget}
        name={name}
        onSelectSingle={onDateRangeChange}
        options={dateRangeOptions}
        validationError={flattenError(validationError)}
        value={dateRangeOptions.find((opt) => opt.id === selectedDateRange)}
      />
      {selectedDateRange === 'custom' && (
        <Group gap={theme.spacing['3']} grow>
          <DateRangeSelects onChange={onCustomDateRangeChange} t={t} value={customDateRange} />
        </Group>
      )}
    </>
  );
}

export default DateRangeSelect;
